import { VariableType } from 'json-to-graphql-query';
export const PermissionsVariables = { permissions: '[String!]!' };
export const PermissionsArgs = { permissions: new VariableType('permissions') };
//# sourceMappingURL=checkPermissions.js.map